import { Slot } from '@bcraft-frontend-lib/slots'

import { ISlotViewItem } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'

type DedupeSlot = Slot | ISlotViewItem

export const getSlotDedupeKey = (slot: DedupeSlot): string => {
  if ('externalId' in slot) {
    return `${slot.id}:${slot.integrationName}:${slot.externalId}:${slot.provider}`
  }

  const legacySlot = slot as ISlotViewItem

  return `${legacySlot.gameId}:${legacySlot.provider}:${legacySlot.routeProvider || ''}`
}

export const deduplicateSlots = <T extends DedupeSlot>(slots: T[]): T[] => {
  const seen = new Set<string>()

  return slots.filter(slot => {
    const key = getSlotDedupeKey(slot)

    if (seen.has(key)) {
      return false
    }

    seen.add(key)
    return true
  })
}
